import React from 'react';
import { TextInput } from './form-components/input';
import './RequestQuoteInput.scss';

const RequestQuotePersonalInformationInput = ({ errors, touched, formik }) => (
  <form className="request-quote-input request-quote-input--grid">
    <TextInput
      name="fullName"
      placeholder="Full name"
      errors={errors.fullName}
      touched={touched.fullName}
      isInputWhite
      dataSal=""
      formik={formik}
    />
    <TextInput
      name="email"
      placeholder="Email address"
      errors={errors.email}
      touched={touched.email}
      isInputWhite
      dataSal=""
      formik={formik}
    />
    <TextInput
      name="phone"
      placeholder="Phone number (optional)"
      errors={errors.phone}
      touched={touched.phone}
      isInputWhite
      dataSal=""
      formik={formik}
    />
    <TextInput
      name="companyName"
      placeholder="Company name (optional)"
      errors={errors.companyName}
      touched={touched.companyName}
      isInputWhite
      dataSal=""
      formik={formik}
    />
  </form>
);

export default RequestQuotePersonalInformationInput;
